import { Columns, Column, Box } from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import SellingABusinessSvg from 'src/images/SellingABusiness.svg';

import FindOutMore from '../FindOutMore/FindOutMore';
import SellingMessage from '../SellingMessage/SellingMessage';

import * as styles from './style.css';

const DesktopMessage = () => (
  <Columns space="none">
    <Column width="1/2">
      <Box paddingX={['none', 'large', 'large']}>
        <SellingMessage>
          <FindOutMore />
        </SellingMessage>
      </Box>
    </Column>
    <Column width="1/2">
      <Box className={styles.svgContainer}>
        <CustomSvg svg={SellingABusinessSvg} width={380} />
      </Box>
    </Column>
  </Columns>
);

export default DesktopMessage;
